import { animate, AnimationMetadata, style } from '@angular/animations';

export const slideLeftInAnimation: AnimationMetadata[] = [
  style({
    opacity: 0,
    position: 'fixed',
    left: '0',
    transform: `translate(calc(50vw - 50% + 200px))`,
  }),
  animate('.2s', style({ transform: `translate(calc(50vw - 50%))`, opacity: 1 })),
];

export const slideLeftOutAnimation: AnimationMetadata[] = [
  style({ transform: 'translateX(0)', opacity: 1 }),
  animate('.2s', style({ transform: 'translateX(-200px)', opacity: 0 })),
];

export const slideRightInAnimation: AnimationMetadata[] = [
  style({
    opacity: 0,
    position: 'fixed',
    left: '0',
    transform: `translate(calc(50vw - 50% - 200px))`,
  }),
  animate('.2s', style({ transform: `translate(calc(50vw - 50%))`, opacity: 1 })),
];

export const slideRightOutAnimation: AnimationMetadata[] = [
  style({ transform: 'translateX(0)', opacity: 1 }),
  animate('.2s', style({ transform: 'translateX(200px)', opacity: 0 })),
];

export const fadeInAnimation: AnimationMetadata[] = [
  style({
    position: 'fixed',
    opacity: 0,
    left: '0',
    transform: 'translate(calc(50vw - 50%), 100px)',
  }),
  animate('.2s', style({ opacity: 1, transform: `translate(calc(50vw - 50%), 0)` })),
];

export const fadeOutAnimation: AnimationMetadata[] = [
  animate(
    '.2s',
    style({
      opacity: 0,
      transform: 'translate(0)',
    }),
  ),
];
